export const LOCAL_STORAGE_NO_SHOW_KEY = 'event-popup-no-show';
